import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../config/seoConfig';
import { useLanguage } from '../context/LanguageContext';

const TermsOfService = () => {
  const { language } = useLanguage();
  const seoData = getSEOConfig('terms', language);

  const content = {
    en: {
      title: "Terms of Service",
      lastUpdated: "Last Updated: December 15, 2024",
      intro: "These Terms of Service govern your use of the DSI Durango website and services. By accessing our website, you agree to these terms.",
      sections: [
        {
          title: "1. Services",
          content: "DSI Durango provides CNC machining, harness fixture manufacturing, and industrial automation services. All services are subject to quote approval and availability."
        },
        {
          title: "2. Quotes and Pricing",
          content: "Quotes are valid for 30 days unless otherwise stated. Final pricing may vary based on project specifications and material costs."
        },
        {
          title: "3. Intellectual Property",
          content: "All designs, drawings, and intellectual property created by DSI Durango remain our property until full payment is received."
        },
        {
          title: "4. Limitation of Liability",
          content: "DSI Durango is not liable for indirect, incidental, or consequential damages arising from the use of our services or website."
        },
        {
          title: "5. Governing Law",
          content: "These terms are governed by the laws of Mexico. Any disputes shall be resolved in the courts of Durango, Mexico."
        },
        {
          title: "6. Contact",
          content: "For questions about these terms, contact us at ventas@dsidurango.com"
        }
      ]
    },
    es: {
      title: "Términos de Servicio",
      lastUpdated: "Última actualización: 15 de diciembre de 2024",
      intro: "Estos Términos de Servicio rigen el uso del sitio web y servicios de DSI Durango. Al acceder a nuestro sitio web, acepta estos términos.",
      sections: [
        {
          title: "1. Servicios",
          content: "DSI Durango proporciona servicios de maquinado CNC, fabricación de fixtures para arneses y automatización industrial. Todos los servicios están sujetos a aprobación de cotización y disponibilidad."
        },
        {
          title: "2. Cotizaciones y Precios",
          content: "Las cotizaciones son válidas por 30 días salvo que se indique lo contrario. El precio final puede variar según las especificaciones del proyecto y costos de materiales."
        },
        {
          title: "3. Propiedad Intelectual",
          content: "Todos los diseños, dibujos y propiedad intelectual creados por DSI Durango permanecen como nuestra propiedad hasta que se reciba el pago completo."
        },
        {
          title: "4. Limitación de Responsabilidad",
          content: "DSI Durango no es responsable de daños indirectos, incidentales o consecuentes que surjan del uso de nuestros servicios o sitio web."
        },
        {
          title: "5. Ley Aplicable",
          content: "Estos términos se rigen por las leyes de México. Cualquier disputa se resolverá en los tribunales de Durango, México."
        },
        {
          title: "6. Contacto",
          content: "Para preguntas sobre estos términos, contáctenos en ventas@dsidurango.com"
        }
      ]
    }
  };

  const t = content[language];

  return (
    <>
      <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        ogImage={seoData.ogImage}
      />
      
      <Header />
      
      <main className="min-h-screen bg-black pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.title}
          </h1>
          <p className="text-gray-400 mb-8">{t.lastUpdated}</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              {t.intro}
            </p>

            {t.sections.map((section, index) => (
              <div key={index} className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">
                  {section.title}
                </h2>
                <p className="text-gray-300 leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </>
  );
};

export default TermsOfService;
